/** Event */
export default {
  create: 'Creating',
  createProgramme: 'AI Creating Programme',
  aiProgramme: 'ai programme',
  name: 'Activity Name',
  placeholder: 'Enter Activity Name',
  total: 'Total Registrations',
  likes: 'Total Number of likes',
  income: 'Total registration income',
  tips: {
    total: 'The number of applicants does not include cancellations',
    income: 'Income does not include refunds, rewards, and product sales '
  },
  table: {
    name: 'Activity Name',
    status: 'Activity Status',
    total: 'Total Registrations',
    today: "Today's Registrations",
    last_week: "Last week's Registrations",
    create: 'Created Time',
    update: 'Updated Time',
    start: 'Start Time',
    end: 'End Time',
    operate: 'Operation',
    oper: {
      data: 'Registration Data',
      config: 'Content Configuration',
      progress: 'Progress Configuration',
      display: 'Activity Display',
      screen: 'Data Screen',
      share: 'Activity Sharing',
      more: 'More Functions',
      mores: {
        setting: 'Display Settings',
        ad: 'Ad Settings',
        live: 'Image Living Broadcast',
        video: 'Video Highlights',
        qrcode: 'Sign-in QR code',
        gift: 'Gifts and Prizes'
      }
    },
    total_number: 'Total {total} Items'
  },
  create_form: {
    placeholder: 'Please Enter',
    status: {
      '是否确认立刻发布活动?': 'Are you sure to publish the activity immediately?'
    },
    content: {
      title: 'Activity Content',
      name: {
        label: 'Activity Name',
        hover: "Activity the name of this activity, for example: the first children's painting exhibition"
      },
      cycle: {
        label: 'Activity Cycle',
        hover:
          'The entire activity time, from the start to the end: For example: 2024.01.20 ~ 2024.05.20; if not decided, please estimate a time period'
      },
      stage: {
        title: 'Activity Stage',
        desc: 'Only one phase can be created now. To add more, finish the initial setup, then use "Advanced Configuration" in the activity list.',
        name: {
          title: 'Phase Name',
          hover:
            'The name of the activity stage. Currently, only one stage can be established; for example: first round or second round or audition or final'
        },
        start: {
          title: 'Registration Time',
          hover:
            'The registration start time and end time of this stage, please be accurate to the minute and second. Note: Registration is not allowed outside the registration  period; if not decided, you can fill it in later'
        },
        hold: {
          title: 'Holding Time',
          hover:
            'The start time and end time of this stage, please be accurate to the minute and second, such as: offline exhibition time period or award ceremony time period; if not decided, you can fill it in later'
        }
      },
      poster: {
        title: 'Activity Poster',
        upload: 'Click to Upload',
        tips: {
          _1: 'Tip: Support .jpg, .png image formats; the maximum image capacity cannot exceed 5MB; the image size ratio should be kept as 1:1 as possible, and the minimum size is 860px*860px',
          _2: "The image will be displayed at the top of the applicant's page, click View the legend"
        }
      },
      detail: {
        desc: 'Visible to the registrants, click to view the legend',
        placeholder: 'Please Enter',
        title: {
          _1: 'activity Introduction',
          _2: 'Registration Rules',
          _3: 'Organization'
        }
      }
    },
    group: {
      title: 'Group Information',
      desc: 'Currently, only one group activity can be established. There are multiple different group activities. Please complete the initial creation of the activity first, and then click the "Activity Configuration - Sub-competition Configuration" of the activity in the activity list to configure it. The activity system supports that different group activities can set different registration fees, registration forms, basic selection, registration forms and other settings',
      category: {
        title: 'Activity',
        hover: 'Example: Art; Dance;',
        add: 'Add Category',
        name: 'Category Name'
      },
      group: {
        title: 'Activity Group',
        hover: 'Example: Youth group; Adult group;',
        add: 'Add Group',
        name: 'Group Name'
      },
      form: {
        title: 'Registration Form',
        hover:
          'The information content that the registrant needs to fill in; different categories or groups can use different registration forms',
        create: 'Create activity registration information'
      },
      charge: {
        title: 'Registration Fee',
        hover: 'Different categories or groups can be set with different fees'
      },
      config: {
        title: 'Detailed configuration settings:',
        hover:
          'Different categories or groups can set different selection rules, selection criteria, selection methods, number of selections, selection results announcement time, etc.',
        repeat: {
          title: 'Repeated registration for the same group:',
          hover: 'Whether a group activity allows users to register multiple times with the same information',
          default: 'Close'
        },
        pass: {
          title: 'Registration review passed:',
          hover:
            'After the user submits the registration, whether the system will review it by default to determine whether the registration is valid/invalid',
          default: 'Automatically passed',
          prepay: 'Review first, then pay',
          postpay: 'Pay first, then review'
        },
        show: {
          title: 'Registration center displays:',
          hover:
            'Individual: registration when filling in one person\'s information; "Team": a registration composed of multiple people\'s information, sharing a work',
          default: 'Display'
        },
        form: {
          title: 'Group registration form:',
          hover:
            'Individual: registration when filling in one person\'s information; "Team": a registration composed of multiple people\'s information, sharing a work',
          default: 'Individual',
          team: 'Team',
          min: 'Minimum team size:',
          max: 'Maximum team size:'
        },
        base: {
          title: 'Basic evaluation function:',
          hover: 'Whether to enable the basic evaluation function; example: Enable or Close',
          default: 'Close'
        },
        commission: {
          title: 'Partner Commission:',
          hover: 'As the subordinate channel of the organizer, the partner sets the commission ratio of the registration fee',
          default: 'Close'
        },
        inherit: {
          title: 'Selection number inheritance:',
          hover:
            'In the advanced selection management in the main menu, you can set the selection number of the registered works, and the number can be inherited to the next round when advancing',
          default: 'Close'
        }
      }
    },
    session: {
      title: 'Session Information',
      desc: 'Tip: The current session creation is only associated with the group activity created in the previous step. Multiple group activities have session arrangements. Please complete the initial creation of the activity first, enter the activity management, and click "Activity Configuration - Sub-competition Configuration - Session Configuration" to configure it. A single group can create multiple sessions, and different groups can also create different sessions.',
      name: 'Group activities',
      number: {
        title: 'Registrants',
        hover:
          'Registrants are set for a single session. If there are multiple sessions, the number of participants for each session needs to be set separately',
        config: 'Settings',
        default: 'Unlimited'
      },
      arrange: {
        title: 'Session Arrangements',
        hover:
          'If the relevant session arrangements have not been determined, you can close it; if there are already session arrangements, you can open it for settings, supporting online and offline',
        default: 'Close'
      },
      form: 'Session format:',
      online: 'Online address',
      offline: 'Region selection',
      address: 'Detailed address',
      time: 'Session time'
    }
  }
}



// WEBPACK FOOTER //
// ./src/langs/en/activity.js